angular.module("app").controller("ProvidersEditPageController", [
    '$scope',
    '$filter',
    'preloadedData',
    'preloadedParentsList',
    'casinoProviderService',
    'errorHandler',
    'logger',
    'pageStatuses',
    'deepCompare',
    '$uibModalInstance',
    'countryCodes',
    'settingsService',
    function ($scope, $filter, preloadedData, preloadedParentsList, casinoProviderService, errorHandler, logger, pageStatuses, deepCompare, $modalInstance, countryCodes, settingsService) {
        $scope.tooltip = {
            name: "",
            title: ""
        };
        var countryNameCodeMap = {};
        var countryCodeNameMap = {};
        $scope.countryCodes = countryCodes.data.map(function (item) {
            countryNameCodeMap[item.name] = item["alpha-2"];
            countryCodeNameMap[item["alpha-2"]] = item.name;
            return item.name;
        });
        $scope.parents = preloadedParentsList.providers;
        
        $scope.pageStatuses = pageStatuses;

        var translator = $filter('translate'),
            settings = settingsService.getSettings();


        var tmpLanguages = [], addElementHelper;

        angular.forEach(settings.languages, function (lang) {
            if (lang == 'en') return true;

            tmpLanguages.push({
                id: lang,
                title: lang.toUpperCase() + ' - ' + translator('top_menu.languages.' + lang),
                placeholder: 'Name'
            });
        });

        $scope.languages = tmpLanguages;

        $scope.save = function () {
            addElementHelper = $scope.useAddElementHelper();
            if (!$scope.edit_providers_form.$valid) {
                return;
            }else if ($scope.isAllowedToUpdate()){
                logger.logError("global.no_changes");
                return;
            }
            var requestData = {
                    casinoProvider: {}
                },
                changes;
            var fetchedData = fetchData();

            changes = deepCompare.getChanges(preloadedData.provider, fetchedData);
            var blockedCountries = $scope.providerData.blocked_countries.map(function (item) {
                return countryNameCodeMap[item];
            });
            if (fetchedData.translations) {
                changes = changes || {};
                changes.name = preloadedData.provider.name;
                changes.translations = fetchedData.translations;
            }
            if (! angular.equals(preloadedData.provider.blocked_countries, blockedCountries)) {
                changes = changes || {};
                changes.blocked_countries = blockedCountries;
            } else {
                delete changes.blocked_countries;
            }

            changes.name = preloadedData.provider.name;
            requestData.casinoProvider = changes;
            casinoProviderService.edit(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedData.provider = fetchData();
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isAllowedToUpdate = function () {
            var fetchedData = fetchData();
            fetchedData.blocked_countries = fetchedData.blocked_countries.map(function (item) {
                return countryNameCodeMap[item];
            });
            return deepCompare.isEqual(fetchedData, preloadedData.provider)
        };

        function init () {
            $scope.providerData = angular.copy(preloadedData.provider);
            $scope.providerData.blocked_countries = $scope.providerData.blocked_countries.map(function (item) {
                return countryCodeNameMap[item];
            }) || [];
            $scope.edit_providers_form && $scope.edit_providers_form.$setPristine();
            if ($scope.providerData.translations !== undefined && $scope.providerData.translations.title !== undefined) {
                $scope.providerTitleTranslation = angular.copy($scope.providerData.translations.title);
            }
        }

        function fetchData () {
            var data = angular.copy($scope.providerData);
            data.translations = addElementHelper.fetchData('providerTitleTranslation');
            return data;
        }

        init();

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
